import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    data() {
        return {
            loadingCourseApplications: false,
            courseApplications: [],
        }
    },
    methods: {
        ...mapActions({
            FetchCurrentApplicantCoursesByStudentID: 'enterpriseDataApi/FetchCurrentApplicantCoursesByStudentID',
        }),
        LoadCurrentCourseApplicationsByStudentID() {
            eventBus.$emit('course-applications-fetch:started');
            this.loadingCourseApplications = true;
            this.FetchCurrentApplicantCoursesByStudentID({ StudentID: this.student.StudentID })
                .then(response => {
                    this.courseApplications = [...response];
                    eventBus.$emit('course-applications-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => {
                    this.loadingCourseApplications = false;
                    eventBus.$emit('course-applications-fetch:finished');
                });
        },
        GetCourseApplicationStatusColor(status) {
            switch (status) {
                case 'CANC': return 'error';
                default: return 'info';
            }
        }
    }
};